import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

function TPATable({ tpaData }) {

    const tableHeader = ["Contact Name", "Contact Number", "Approved"];
  return (
    <TableContainer
      component={Paper}
      sx={{
        backgroundColor: "#F9FBFC",
        maxHeight: "60vh",
        borderRadius: "10px",
        boxShadow: "rgba(149, 157, 165, 0.1) 0px 2px 14px;",
        "&::-webkit-scrollbar": {
          width: "5px",
          backgroundColor: "#F5F5F5",
        },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: "4px",
          backgroundColor: "#17dfba86",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#17dfba",
        },
      }}>
      <Table
        style={{
          backgroundColor: "white",
        }}
        aria-label="table">
        <TableHead
          sx={{
            position: "sticky",
            bgcolor: "white",
            top: 0,
            zIndex: 999,
            border: "none",
          }}>
          <TableRow>
            {tableHeader.map((item) => (
              <TableCell
                style={{ fontSize: "14px" }}
                sx={{ color: "#4C5A6A" }}
                key={item + Math.random()}>
                <span style={{ fontSize: "14px", fontWeight: 500 }}>
                  {item}
                </span>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tpaData.map((data) => (
            <TableRow sx={{ width: "40%" }}>
              <TableCell>{data.contactName}</TableCell>
              <TableCell>{data.contactNumber}</TableCell>
              <TableCell>
                {data.approved ? "Approved" : "Not Approved"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default TPATable;
